const Input = {
	baseStyle: {
		color: 'brand.500 !important',
	},
}

export default Input
